import Vue from "vue";
import Helper from "./helper";
import Faker from "./faker";
import Data from "./data";
import Lodash from "./lodash";

Vue.use(Helper);
Vue.use(Faker);
Vue.use(Data);
Vue.use(Lodash);
